import { useActiveContact } from '../../hooks/active-contact.hook';
import { ContactDetailsTitle } from '../titles/ContactDetailsTitle';

export const ContactDetailsPageNav = (): React.ReactElement<any, any> | null => {
    const { contact } = useActiveContact();

    return <ContactDetailsTitle contact={contact} />;
};
